import React from 'react';
import {PageTitle} from '../../common/pageTitle/PageTitle';

import './eightOneOneCallout.scss';

/**
 * The FactsAndStatsPage component.
 *
 * @constructor
 */
export class EightOneOneCallout extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div className="eightOneOneCallout">
        <div className="whiteCalloutDiv">
          <div className="content">
            <div className="circleContainer">
              <img src={this.props.imgStep} height="85px" width="85px" />
            </div>
            <div className="stepsText">
              <p>{this.props.text}</p>
              <div className="bulletSection">
                <p>{this.props.secondParagraph}</p>
                <div className="title">{this.props.title}</div>

                <ul>
                  {this.props.bulletOne &&<li>{this.props.bulletOne}</li>}
                  {this.props.bulletTwo &&<li>{this.props.bulletTwo}</li>}
                  {this.props.bulletThree &&<li>{this.props.bulletThree}</li>}
                  {this.props.bulletFour &&<li>{this.props.bulletFour}</li>}
                </ul>

                {this.props.hascgaText && <p> To facilitate voluntary data collection reporting that is used to inform industry, consider submitting damage prevention and near-miss reports through a secure, private web application, Damage Information Reporting Tool (DIRT) at <a href="https://www.cga-dirt.com">www.cga-dirt.com</a>, which has been set up by the Common Ground Alliance.</p>}

              </div>


            </div>
          </div>
      </div>
      </div>
    );
  }
}

EightOneOneCallout.propTypes = {};

export default EightOneOneCallout;



// WEBPACK FOOTER //
// ./src/components/common/eightOneOneCallout/eightOneOneCallout.js